import Tag from '../Tag';

interface Props {
  tags: string[] | null | undefined;
}

export function TagsCell({ tags }: Props) {
  return (
    <div className="flex flex-wrap2 gap-1">
      {tags?.map((tag) => (
        <Tag key={tag} tag={tag} size="sm" />
      ))}
    </div>
  );
}
